export interface IContact {
  dob: string
  phone: string
  title: string
  last_name: string
  first_name: string
  middle_name: string
  former_surname: string
}

export function contactFactory(data?: IContact): IContact {
  return {
    dob: data?.dob || '',
    phone: data?.phone || '',
    title: data?.title || '',
    last_name: data?.last_name || '',
    first_name: data?.first_name || '',
    middle_name: data?.middle_name || '',
    former_surname: data?.former_surname || ''
  }
}
